/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .directive('imageLoader', function () {
    return {
      restrict: 'A',
      link: imageLoader
    };
  });

function imageLoader(scope, element, attrs) {
  element.hide();
  element.parent().addClass('bg-loader-spinner');
  element.parent().append('<i class="fa fa-spinner loader-spinner fa-lg fa-pulse"></i>');
  element.parent().append('' +
    '<img ' +
      'class="temp-image" ' +
      'src="' + attrs.miniImage + '" ' +
      'width="' + attrs.miniWidth + '" ' +
      'height="' + attrs.miniHeight + '" ' +
    '/>');

  element.bind('load', function () {
    element.next('i.fa-spinner').remove();
    element.next('img').remove();
    element.show();
  });
}

